import { ReactNode, useEffect, useMemo, useState } from "react";
import { OptionMenu } from "../../utils/OptionMenu";
import { EditVisitOption } from "./EditVisitOption";
import { CancelVisitOption } from "./CancelVisitOption";
import { ConfirmedDeal } from "../../../types/empresa";
import { ModalContainer } from "../../UtilitiesComponents/ModalContainer";
import { ChangeDealStageFormContainer } from "../../PipelineComponents/ChangeDealStageForms/ChangeDealStageFormContainer";

interface Props {
    deal: ConfirmedDeal;
}

export function VisitOptionMenu({ deal }: Props) {
    const [currentOption, setCurrentOption] = useState<ReactNode | null>(null);
    const [showModal, setShowModal] = useState(false);

    const visitaOptions = useMemo<ReactNode[]>(() => [
        <EditVisitOption 
            setShowEditModal={setShowModal}
            setCurrentOption={setCurrentOption}
            deal={deal}/>,
        // TODO: this option will be enable soon the feature is completed
        // <CancelVisitOption 
        //     setShowModal={setShowModal}
        //     setCurrentOption={setCurrentOption}
        //     deal={deal}/>,
    ], []);

    useEffect(() => {
        if(currentOption)
            setShowModal(true);
        else
            setShowModal(false);
    }, [currentOption]);

    return (
        <>
            <OptionMenu options={visitaOptions}/>

            {showModal && currentOption && (
                <ModalContainer>
                    <ChangeDealStageFormContainer
                        largeWidht
                        setShowModal={setShowModal}>
                        {currentOption}
                    </ChangeDealStageFormContainer>
                </ModalContainer>
            )}
        </>
    );
}
